export default __webpack_public_path__ + "static/media/cbridgev2.504ae2ac.svg";